<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      no-enforce-focus>
      <form autocomplete="off" @submit.prevent="submitForm">
        <div class="modal-body">
          <div class="row container-fluid">
            <div class="form-group col-md-12">
              <label for="course"><b>Curso&nbsp;<span class="asterisk">*</span></b></label>
              <v-select v-model="form.coursename" :options="courses" class="my-custom-select" placeholder="Seleccione..."></v-select>
              <span v-if="courseValid" class="text-danger" style="font-size: 10px;"><b>El campo Curso es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for="module"><b>Módulo&nbsp;<span class="asterisk">*</span></b></label>
              <input v-model="form.module" type="text" class="form-control" id="module" name="module" placeholder="Módulo">
              <span v-if="moduleValid" class="text-danger" style="font-size: 10px;"><b>El campo Módulo es requerido.</b></span>
            </div>

            <div class="form-group col-md-6">
              <label for="module"><b>Tiempo de Lectura&nbsp;<span class="asterisk">*</span></b></label>
              <input type="text" v-mask="'##:##:##'" placeholder="00:00:00" v-model="form.read_time" class="form-control" id="read_time" name="read_time" />
              <cite class="" style="font-size: 10px;">hh:mm:ss</cite>
              <br v-if="readtimeValid">
              <span v-if="readtimeValid" class="text-danger" style="font-size: 10px;"><b>El campo Tiempo de Lectura es requerido.</b></span>
            </div>

            <div class="form-group col-md-6">
              <label for="module"><b>Tiempo de Práctica&nbsp;<span class="asterisk">*</span></b></label>
              <input type="text" v-mask="'##:##:##'" placeholder="00:00:00" v-model="form.practice_time" class="form-control" id="practice_time" name="practice_time" />
              <cite class="" style="font-size: 10px;">hh:mm:ss</cite>
              <br v-if="practicetimeValid">
              <span v-if="practicetimeValid" class="text-danger" style="font-size: 10px;">El campo <b>Tiempo de Práctica es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for=""><b>Descripción&nbsp;<span class="asterisk">*</span></b></label>
              <ckeditor ref="editor" v-model="form.description" :editor="editor" type="classic" :config="editorConfig"></ckeditor>
              <span v-if="descriptionValid" class="text-danger" style="font-size: 10px;"><b>El campo Descripción es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for="video"><b>Video&nbsp;</b></label>
              <input ref="video" @change="handleFileChange" type="file" class="form-control" id="video" name="video" accept="video/mp4">
              <cite v-if="form.url_video" style="font-size: 10px;">El módulo ya posee un video; si sube otro, lo reemplaza.</cite>
            </div>

          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-select/dist/vue-select.css';
import { BModal, BFormTimepicker } from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ClassicEditor, editorConfig } from '../../../../ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {TheMask} from 'vue-the-mask'


export default {
  components: {BModal, BFormTimepicker, vSelect, 'ckeditor': CKEditor.component, TheMask},
  props: ['id', 'showModal'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig,
      name: 'ckeditor',
      form: {
        video: null, // Aquí almacenaremos el archivo seleccionado
        description: ''
      },
      courseValid: false,
      moduleValid: false,
      readtimeValid: false,
      practicetimeValid: false,
      descriptionValid: false,
      loading: false,
      textMessage: 'Crear Módulo',
      courses: []
    }
  },
  created() {
      this.getCourses()
  },
  methods:{
    handleFileChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.video = event.target.files[0] || null;
    },
    handleInput(event) {
      const input = event.target;
      const cursorPos = input.selectionStart;

      // Si se han ingresado dos dígitos para la hora, mover el cursor al próximo espacio (minutos)
      if (cursorPos === 2) {
        input.setSelectionRange(3, 3);
      }
    },
    close(bvModalEvent) {
      this.textMessage = 'Crear Módulo'
      this.$emit('update:showModal', false)
      this.$emit('getRecords')
    },
    cancel(bvModalEvent) {
      this.textMessage = 'Crear Módulo'
      this.$emit('update:showModal', false)
    },
    resetForm() {
      // Este método se ejecutará cuando el modal se oculte
      this.form = {
        video: null,
        description: ''
      };
      // El input de archivo no se reinicia solo: el modal no se destruye al cerrarse
      if (this.$refs.video) {
        this.$refs.video.value = '';
      }
      this.courseValid = false;
      this.moduleValid = false;
      this.readtimeValid = false;
      this.practicetimeValid = false;
      this.descriptionValid = false
    },
    getCourses() {
      axios.get(`/administration/courses/modules/getCourses`)
        .then(response => {
            this.courses = response.data.data
        })
    },
    getRecord() {
      this.loading = true
      if(this.id) {
        axios.get(`/administration/courses/modules/${this.id}`)
        .then(response => {
            this.textMessage = 'Editar Módulo'
            this.form = response.data
            this.form.coursename = {
              value: response.data.coursename.value,
              label: response.data.coursename.label
            };
        })
        .finally(() => {
          this.loading = false
        })
      } else {
        this.form = {
          video: null,
          description: ''
        }
      }
    },
    submitForm() {
      this.loading = true

      this.courseValid = false;
      this.moduleValid = false;
      this.readtimeValid = false;
      this.practicetimeValid = false;
      this.descriptionValid = false;

      // Validar campos
      if (this.form.coursename == '' || this.form.coursename == null) {
        this.courseValid = true;
      }

      if (this.form.module == '' || this.form.module == null) {
        this.moduleValid = true;
      }

      if (this.form.read_time == '' || this.form.read_time == null) {
        this.readtimeValid = true;
      }

      if (this.form.practice_time == '' || this.form.practice_time == null) {
        this.practicetimeValid = true;
      }

      if (this.form.description == '') {
        this.descriptionValid = true;
      }

      // Si algún campo no es válido, detener el envío del formulario
      if (this.courseValid == true || this.moduleValid == true || this.readtimeValid == true || this.practicetimeValid == true || this.descriptionValid == true) {
        return;
      }

      // Se envía como FormData para poder adjuntar el video
      let formData = new FormData();
      if (this.id) {
        formData.append('id', this.form.id);
      }
      formData.append('coursename[value]', this.form.coursename.value);
      formData.append('module', this.form.module);
      formData.append('read_time', this.form.read_time);
      formData.append('practice_time', this.form.practice_time);
      formData.append('description', this.form.description);
      // Solo se adjunta si se eligió un archivo nuevo; si no, se conserva el video actual
      if (this.form.video instanceof File) {
        formData.append('video', this.form.video);
      }

      axios.post('/administration/courses/modules', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
          }
          this.close();
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
          } else if (error.response && error.response.status === 413) {
            toastr.error('El video supera el tamaño máximo permitido por el servidor.', 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error('No se pudo guardar el registro', 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    filterOptions(options, search, label) {
      // Puedes personalizar la lógica de filtrado según tus necesidades
      return options.filter(option => option[label].toLowerCase().includes(search.toLowerCase()));
    },
  }
}

</script>

<style>
#__BVID__6___BV_modal_outer_ {
  /*z-index: 1000 !important;*/
  z-index: calc(var(--ck-z-panel) + 40) !important;
}
.ck-rounded-corners .ck.ck-balloon-panel {
  z-index: calc(var(--ck-z-panel) + 41) !important;
}
</style>